import React from "react";
import Package from "./../../assets/img/banner-engineering.gif";
const Engineering = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Engineering</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <div className="row mb-1 justify-content-between">
              <div className="col-lg-8 ">
                <p>
                  HSDC has six Cereal Seed Processing Plants of different
                  capacity at Umri (Dist. Kurukshetra), Hisar, Sirsa, Yamuna
                  Nagar, Tohana (Distt. Fatehabad) and Pataudi (Distt. Gurgaon).
                  HSDC also has one Vegetable Seed Processing Plant at Umri
                  (Distt. Kurukshetra).<br/>HSDC has wide range of sophisticated
                  processing machinery/ equipments suited for seed separation
                  based on different criteria like size, shape, weight, texture
                  etc.
                </p>
              </div>
              <div className="col-lg-4  text-center">
                <img
                  src={Package}
                  alt="Seed Production"
                  className="img-fluid rounded shadow-sm"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 mb-1">
            <p>
              The Plants are equipped with latest machinery of different types
              like Seed Cleaner & Graders, Gravity Separators, Indented Cylinder
              Graders, Seed Treators, Automatic Weighing & Packaging Machines.
              Further, Air Pollution Control System has also been installed at
              all the six unit to miniimize the Air Pollution and to provide
              free Atmosphere to the employees working at Seed Processing Plant.
              HSDC has established Modern Seed Testing Lab with sophisticated
              equipments at Umri (Distt. Kurukshetra).
            </p>
            <p>
              The installed and storage capacity of Seed Processing Plants are
              as under:-
            </p>
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <th id="plant" rowspan="2" scope="col">
                      Sr. No.
                    </th>
                    <th id="plant1" rowspan="2" scope="col">
                      Name of the Plant
                    </th>
                    <th colspan="2" id="plant2" scope="col">
                      (in qtls.)
                    </th>
                  </tr>
                  <tr>
                    <th>Processing Capacity per Hour&nbsp;</th>
                    <th>Storage Capacity</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>
                      Umri
                      <br />
                      (Distt. Kurukshetra)
                    </td>
                    <td>100.00</td>
                    <td>110000</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Yamuna Nagar</td>
                    <td>50.00</td>
                    <td>45000</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Hisar</td>
                    <td>100.00</td>
                    <td>88000</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Sirsa</td>
                    <td>100.00</td>
                    <td>84500</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>
                      Tohana
                      <br />
                      (Distt. Fatehabad)
                    </td>
                    <td>50.00</td>
                    <td>54000</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>
                      Pataudi
                      <br />
                      (Distt. Gurgaon)
                    </td>
                    <td>90.00</td>
                    <td>67500</td>
                  </tr>
                  <tr>
                    <td className="bold">&nbsp;</td>
                    <td className="bold">Total</td>
                    <td className="bold">490.00</td>
                    <td className="bold">4,49,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Engineering;
